/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Clickup_PricingInputs */

const en_mk_cmp_clickup_pricing = /** @type {(inputs: Mk_Cmp_Clickup_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited $7 · Business $12 · Enterprise by agreement, per seat per month (billed annually). AI add-on: Brain $9 or Everything AI $28 per seat.`)
};

const id_mk_cmp_clickup_pricing = /** @type {(inputs: Mk_Cmp_Clickup_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited $7 · Business $12 · Enterprise sesuai kesepakatan, per kursi per bulan (tagihan tahunan). Add-on AI: Brain $9 atau Everything AI $28 per kursi.`)
};

/**
* | output |
* | --- |
* | "Unlimited $7 · Business $12 · Enterprise by agreement, per seat per month (billed annually). AI add-on: Brain $9 or Everything AI $28 per seat." |
*
* @param {Mk_Cmp_Clickup_PricingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_clickup_pricing = /** @type {((inputs?: Mk_Cmp_Clickup_PricingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Clickup_PricingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_clickup_pricing(inputs)
	return en_mk_cmp_clickup_pricing(inputs)
});